export const selectQueues = (state) => [state.queues, state.setQueues]
export const selectError = (state) => [state.error, state.setError]
export const selectReset = (state) => state.resetQueues
